<template>
    <div class="stripo">
        <div id="stripoSettingsContainer"></div>
        <div id="stripoPreviewContainer"></div>
    </div>
</template>
<style lang="scss">
.stripo {
    width: 100%;
    height: 100%;

    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background: #f00;
    .nav {
        display: block;
    }
    .full-height {
        height: 100%;
    }
    #stripoSettingsContainer {
        width: 350px;
        height: 100%;
        float: left;
        background: #0ee;
    }
    #stripoPreviewContainer {
        height: 100%;
        width: calc(100% - 350px);
        float: left;
    }
}
</style>
<script>
import keviApi from "../../keviApi";
import html from "./templates/empty.html";
import css from "./templates/empty.js";
export default {
    name: "stripo",
    props: {
        emailId: {
            type: String,
            default: "",
        },
    },
    data: () => ({
        stripo: null,
    }),
    async mounted() {
        console.log("mounted");
        const stripo = await this.loadScript();
        console.log(stripo);
        this.initialize();
    },
    methods: {
        loadScript() {
            return new Promise((resolve) => {
                if (window.Stripo) {
                    resolve("Stripo already loaded");
                } else {
                    const script = document.createElement("script");
                    script.src =
                        "https://plugins.stripo.email/static/latest/stripo.js";
                    script.onload = () => {
                        resolve("Stripo loaded");
                    };
                    document.head.appendChild(script);
                }
            });
        },
        initialize() {
            window.Stripo.init({
                settingsId: "stripoSettingsContainer",
                previewId: "stripoPreviewContainer",
                html: html,
                css: css,
                locale: "pt",
                apiRequestData: {
                    emailId: this.emailId,
                },
                getAuthToken: async (callback) => {
                    const response = await this.$http(
                        keviApi.getOptions("automations/stripoToken"),
                    );
                    callback(response.body.token);
                },
            });
        },
    },
};
</script>
